import axios from "../../longLiveAxios";
import { Base64 } from 'js-base64';

const declarationABaseURL = "/api/form";
const baseURL = "/api/declarations";

export default {
  saveDeclaration(payload, buildingId) {
    return axios.post(`${baseURL}/form?building=${buildingId}`, payload);
  },
  updateDeclaration(payload, declarationId) {
    return axios.put(`${baseURL}/form/${declarationId}`, payload);
  },
  getHeatSources() {
    return axios.get(`${baseURL}/soh_types`);
  },
  getBoilerClasses() {
    return axios.get(`${baseURL}/solid_fuel_boiler_classes`);
  },
  getFuelClasses() {
    return axios.get(`${baseURL}/solid_fuel_types`);
  },
  getUserDeclarations(filters={}) {
    let params = new URLSearchParams(filters).toString();
    return axios.get(`${baseURL}/?${params}`);
  },
  getDeclarationById(id) {
    return axios.get(`${baseURL}/form/${id}`);
  },
  printDeclaration(id) {
    return axios.get(`${baseURL}/pdf/${id}`);
  },
  getDeclarationIdByTextid(encoded) {
    return axios.get(`${baseURL}/getbytextid/${encoded}`);
  },
  submitDeclaration(declarationId) {
    return axios.post(`${baseURL}/${declarationId}/submit`);
  },
  deleteDeclaration(declarationId) {
    return axios.delete(`${baseURL}/form/${declarationId}`);
  },
  getBuildingTypesForB() {
    return axios.get(`${baseURL}/building_types/`);
  },
  createEditedDeclaration(declarationId) {
    return axios.post(`${baseURL}/${declarationId}/edit`);
  },
  getDeclarationHistoryById(declarationId) {
    return axios.get(`${baseURL}/${declarationId}/history`);
  },
  verifyDeclarationForAddress(payload) {
    return axios.get(`${baseURL}/verify_for_address?q=` + Base64.encode(JSON.stringify(payload)));
  },
  getDeclarationForVerification(payload) {
    return axios.get(`${baseURL}/get_for_verify?q=` + Base64.encode(JSON.stringify(payload)));
  },
  getDeclarationSummaryById(declarationId) {
    return axios.get(`${baseURL}/${declarationId}/summary`);
  },
  cloneDeclaration(declarationId, buildingId) {
    return axios.post(`${baseURL}/${declarationId}/clone?building=${buildingId}`);
  },
  moveDeclaration(declarationId, buildingId) {
    return axios.post(`${baseURL}/${declarationId}/move?building=${buildingId}`);
  }
}
